export enum DxAuthStorageStrategyType {
  IN_MEMORY = 'IN_MEMORY',
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  SESSION_STORAGE = 'SESSION_STORAGE',
  SERVER_STORAGE = 'SERVER_STORAGE'
}
